<template>
  <header>
    <div class="container">
      <Navigation v-on:showLoginModal="$emit('showLoginModal')"/>
      <div class="content">
        <h1 parallax="0.5">Konferencija za
          <div class="break-on-desktop"></div>
          <b>
            novu generaciju
            <br class="mobile-break">
            <span class="typewriter-blue">
              <span class="pazi-sad"></span>
            </span>
          </b>
        </h1>
        <ul parallax="0.6">
          <li>
            <b>17.</b>
            i
            <b>18.</b>
            svibnja
          </li>
          <li>
            <b>FESB,</b>
            Split
          </li>
        </ul>
        <template v-if="!isLoggedIn">
          <button class="button" v-on:click="$emit('showLoginModal')" parallax="0.7">PRIJAVA</button>
        </template>
        <template v-else>
          <button class="button" v-on:click="routeToApp()" parallax="0.7">APLIKACIJA</button>
        </template>
      </div>
    </div>
  </header>
</template>

<script>
import Navigation from "@/components/landing-page/Navigation.vue";
import Typed from "typed.js";

export default {
  name: "Header",
  computed: {
    isLoggedIn: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      return true;
    }
  },
  methods: {
    isAdmin: function() {
      let token = localStorage.getItem('token');
      if (!token) return false;

      let decoded = this.$decode(token);

      if (!decoded) return false;

      if(decoded.roles === 'Administrator')
        return true;
      return false;
    },
    routeToApp: function() {
      this.isAdmin() ? this.$router.push('admin') : this.$router.push('app');
    }
  },
  mounted: function() {
    var options = {
      strings: ["developera", "dizajnera", "marketingaša", "poduzetnika", "digitalaca"],
      typeSpeed: 100,
      loop: true,
      backSpeed: 80,
      backDelay: 1500
    };

    new Typed(".pazi-sad", options);

    window.addEventListener("scroll", function() {
      let elements = document.querySelectorAll("[parallax]");
      elements.forEach(element => {
        element.style.transform = `translate3d(0,${(element.getAttribute(
          "parallax"
        ) *
          window.scrollY) /
          3}px,0)`;
      });
    });
  },
  components: {
    Navigation
  }
};
</script>

<style scoped>
.mobile-break {
  display: none;  
}

header {
  position: relative;
  background-image: url("../../assets/header.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.typewriter-blue {
  color: #30CEC1;
}

header > video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: #1d9b90;
}

header > .container {
  min-height: 100vh;
  display: flex;
}

.content {
  margin-bottom: 75px;
  margin-top: auto;
}

h1 {
  color: #ffffff;
  font-family: "Fuse V.2 Display", "Arial";
  font-size: 34px;
  font-weight: 400;
  line-height: 40px;
  max-width: 415px;
}

ul {
  margin-top: 20px;
  margin-bottom: 30px;
  list-style-type: none;
}

li {
  display: inline-block;
  color: #fff;
  font-family: "Fuse V.2 Display";
  font-size: 22px;
  letter-spacing: -0.24px;
  line-height: 26px;
}

li:first-of-type {
  margin-right: 15px;
}

li:first-of-type::after {
  content: "|";
  margin-left: 12px;
}

.break-on-desktop {
  display: none;
}

@media screen and (min-height: 600px) {
  .content {
    margin-bottom: 200px;
  }
}

@media screen and (min-width: 1024px) {
  .content {
    margin: 0;
    margin-top: 160px;
  }

  header > .container {
    align-items: center;
  }

  .break-on-desktop {
    display: table;
  }

  h1 {
    font-size: 56px;
    line-height: 56px;
    max-width: 100%;
  }

  ul {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 450px) {
  .mobile-break {
    display: block;
  }
}
</style>